//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../no/View.js";
let d=[[[0,"DisplayAppearance",1,0],[0,"HiddenEdgeColorStyle",1,0],[0,"HiddenEdgeStyle",1,0],[0,"ShadedEdgeColor",1,0],[0,"ShadedEdgeStyle",1,0],[0,"ShininessData",1,0],[0,"SurfaceDisplay",1,1],[0,"TwoSidedLight",1,0]],[],[]];
SPLM.Preferences.ViewVisualizationVisual = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.ViewVisualizationVisual";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.ViewVisualizationVisual.DisplayAppearanceOptions = class{
    constructor(rendering_style,hidden_edges,interfering_solids,silhouettes,smooth_edges,smooth_edge_color,smooth_edge_font,smooth_edge_width,smooth_edge_angle_tolerance){
        this.rendering_style=rendering_style;this.hidden_edges=hidden_edges;this.interfering_solids=interfering_solids;this.silhouettes=silhouettes;this.smooth_edges=smooth_edges;this.smooth_edge_color=smooth_edge_color;this.smooth_edge_font=smooth_edge_font;this.smooth_edge_width=smooth_edge_width;this.smooth_edge_angle_tolerance=smooth_edge_angle_tolerance;}
    get RenderingStyle(){return this.rendering_style}
    set RenderingStyle(val){this.rendering_style = val}
    get HiddenEdges(){return this.hidden_edges}
    set HiddenEdges(val){this.hidden_edges = val}
    get InterferingSolids(){return this.interfering_solids}
    set InterferingSolids(val){this.interfering_solids = val}
    get Silhouettes(){return this.silhouettes}
    set Silhouettes(val){this.silhouettes = val}
    get SmoothEdges(){return this.smooth_edges}
    set SmoothEdges(val){this.smooth_edges = val}
    get SmoothEdgeColor(){return this.smooth_edge_color}
    set SmoothEdgeColor(val){this.smooth_edge_color = val}
    get SmoothEdgeFont(){return this.smooth_edge_font}
    set SmoothEdgeFont(val){this.smooth_edge_font = val}
    get SmoothEdgeWidth(){return this.smooth_edge_width}
    set SmoothEdgeWidth(val){this.smooth_edge_width = val}
    get SmoothEdgeAngleTolerance(){return this.smooth_edge_angle_tolerance}
    set SmoothEdgeAngleTolerance(val){this.smooth_edge_angle_tolerance = val}
};

SPLM.Preferences.ViewVisualizationVisual.SurfaceDisplayOptions = class{
    constructor(rendering_style,hidden_edges,silhouettes,smooth_edges,smooth_edge_color,smooth_edge_font,smooth_edge_width){
        this.rendering_style=rendering_style;this.hidden_edges=hidden_edges;this.silhouettes=silhouettes;this.smooth_edges=smooth_edges;this.smooth_edge_color=smooth_edge_color;this.smooth_edge_font=smooth_edge_font;this.smooth_edge_width=smooth_edge_width;}
    get RenderingStyle(){return this.rendering_style}
    set RenderingStyle(val){this.rendering_style = val}
    get HiddenEdges(){return this.hidden_edges}
    set HiddenEdges(val){this.hidden_edges = val}
    get Silhouettes(){return this.silhouettes}
    set Silhouettes(val){this.silhouettes = val}
    get SmoothEdges(){return this.smooth_edges}
    set SmoothEdges(val){this.smooth_edges = val}
    get SmoothEdgeColor(){return this.smooth_edge_color}
    set SmoothEdgeColor(val){this.smooth_edge_color = val}
    get SmoothEdgeFont(){return this.smooth_edge_font}
    set SmoothEdgeFont(val){this.smooth_edge_font = val}
    get SmoothEdgeWidth(){return this.smooth_edge_width}
    set SmoothEdgeWidth(val){this.smooth_edge_width = val}
};

SPLM.Preferences.ViewVisualizationVisual.RenderingStyle = Object.freeze({
    "Shaded" : "Shaded", "Wireframe" : "Wireframe", "Studio" : "Studio", "FaceAnalysis" : "FaceAnalysis", "PartiallyShaded" : "PartiallyShaded", "StaticWireframe" : "StaticWireframe"});

SPLM.Preferences.ViewVisualizationVisual.HiddenEdges = Object.freeze({
    "Visible" : "Visible", "Invisible" : "Invisible", "GrayThin" : "GrayThin", "Dashed" : "Dashed"});

SPLM.Preferences.ViewVisualizationVisual.InterferingSolids = Object.freeze({
    "Off" : "Off", "On" : "On", "WithCurves" : "WithCurves"});

SPLM.Preferences.ViewVisualizationVisual.SmoothEdgeWidth = Object.freeze({
    "Original" : "Original", "Thin" : "Thin", "Normal" : "Normal", "Thick" : "Thick", "One" : "One", "Two" : "Two", "Three" : "Three", "Four" : "Four", "Five" : "Five", "Six" : "Six", "Seven" : "Seven", "Eight" : "Eight", "Nine" : "Nine"});

SPLM.Preferences.ViewVisualizationVisual.SmoothEdgeFont = Object.freeze({
    "Original" : "Original", "Solid" : "Solid", "Dashed" : "Dashed", "Phantom" : "Phantom", "CenterLine" : "CenterLine", "Dotted" : "Dotted", "LongDashed" : "LongDashed", "DottedDashed" : "DottedDashed", "Eight" : "Eight", "Nine" : "Nine", "Ten" : "Ten", "Eleven" : "Eleven"});

SPLM.Preferences.ViewVisualizationVisual.ShadedEdgeStyleType = Object.freeze({
    "ShadedEdgeColor" : "ShadedEdgeColor", "BodyColor" : "BodyColor", "None" : "None"});

SPLM.Preferences.ViewVisualizationVisual.HiddenEdgeStyleType = Object.freeze({
    "Invisible" : "Invisible", "HiddenGeometryColor" : "HiddenGeometryColor", "Dashed" : "Dashed"});

SPLM.Preferences.ViewVisualizationVisual.HiddenEdgeColorStyleType = Object.freeze({
    "ObjectColor" : "ObjectColor", "HiddenGeometryColor" : "HiddenGeometryColor"});

export default SPLM;